const useTimer = () => {
  const wait = async (ms) => await new Promise((resolve) => setTimeout(resolve, ms));

  return { wait };
};

export default useTimer;
